import {https,httpsFile} from './http.js';

export function show(id){
    return httpsFile().get(`pr-discounts/${id}`)
}

export function update(id,data){
    return httpsFile().post(`pr-discounts/${id}`,data)
}